// extracted by mini-css-extract-plugin
export default {"root":"VehicleNavigationBar-root","jiggle-horizontal":"VehicleNavigationBar-jiggle-horizontal"};